import { RegionUsageRestrictions } from '@packages/types/nds/regionUsageRestrictions';

import fetchWrapper from '../fetchWrapper';

export function fetchRegionUsageRestrictions(groupId: string): Promise<RegionUsageRestrictions> {
  return fetchWrapper(`/nds/${groupId}/regionUsageRestrictions`, {
    method: 'GET',
  }).then((resp) => resp.json());
}
